import {
  Button,
  ChevronLeftSVG,
  Icon,
  SvgComponentType,
} from "@newsela/angelou";
import {
  backToMenuAnchorCss,
  backToMenuIconCss,
  homeMenuSubItemPopoutContainerCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSubItemPopout/HomeMenuSubItemPopout.styles";

const HomeMenuSubItemPopout = ({
  dataTestId,
  onClickBack,
  children,
}: IHomeMenuSubItemPopout) => {
  return (
    <div css={homeMenuSubItemPopoutContainerCss} data-testid={dataTestId}>
      <Button
        onClick={onClickBack}
        __cssFor={backToMenuAnchorCss}
        flavor={Button.flavors.incognito}
      >
        <Icon
          SvgComponent={ChevronLeftSVG as SvgComponentType}
          __cssFor={backToMenuIconCss}
        />
        Back to menu
      </Button>

      {children}
    </div>
  );
};

interface IHomeMenuSubItemPopout {
  dataTestId: string;
  onClickBack: () => void;
  children: React.ReactNode;
}

HomeMenuSubItemPopout.displayName = "HomeMenuSubItemPopout";
export { HomeMenuSubItemPopout };
